import React from 'react';

import {Button, Col, DatePicker, Form, Input, Radio, Row, Select, Space, Switch, Typography} from 'antd';
import {UserCategory, UserGender, UserGrade} from '../../hooks/apis/useUser';
import moment, {Moment} from 'moment';
import ExMdEditor from '../ExMdEditor';

const {Text, Title, Paragraph} = Typography;

export interface IContestNoticeEditForm {
  id?: number;
  title: string;
  content: string;
  publishedDate: Moment;
  isHide: boolean;
}

const ContestNoticeEditForm = (props: {form?: IContestNoticeEditForm; isLoading: boolean; onFinish: (value: IContestNoticeEditForm) => any}) => {
  const [form] = Form.useForm();

  const defaultForm: IContestNoticeEditForm = {
    isHide: false,
    title: '',
    content: '',
    publishedDate: moment(),
  };

  React.useEffect(() => {
    form.setFieldsValue(props.form || defaultForm);
  }, [props.form]);

  return (
    <Form
      labelCol={{span: 6}}
      wrapperCol={{span: 14}}
      layout={'horizontal'}
      form={form}
      onFinish={value => {
        value.id = props.form?.id;
        props.onFinish(value as IContestNoticeEditForm);
      }}>
      <Form.Item label={'通知标题'} name={'title'} rules={[{required: true}]}>
        <Input size={'large'} placeholder="请输入通知标题" />
      </Form.Item>
      <Form.Item label={'通知内容'} name={'content'} rules={[{required: true}]}>
        <ExMdEditor />
      </Form.Item>
      <Form.Item label={'发布时间'} name={'publishedDate'} rules={[{required: true}]}>
        <DatePicker size={'large'} showTime placeholder="请输入发布时间" />
      </Form.Item>
      <Form.Item label={'是否隐藏'} name={'isHide'} valuePropName={'checked'} rules={[{required: true}]}>
        <Switch />
      </Form.Item>
      <Row>
        <Col span={6} />
        <Col>
          <Space>
            <Button size={'large'} type="primary" loading={props.isLoading} htmlType="submit" className="login-form-button">
              保存
            </Button>
          </Space>
        </Col>
      </Row>
    </Form>
  );
};

export default ContestNoticeEditForm;
